import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../../../redux-toolkit/features/slices/authSlice/authSlice';
import { Spinner } from 'react-bootstrap';
import { useGetAuthorizedDataByIdQuery } from '../../../redux-toolkit/services/AdminAuthorizedApi/AdminAuthorizedApi';

const AuthorizedPage = () => {

    const navigate = useNavigate();
    const { id } = useParams();

    const { data, isLoading, isError } = useGetAuthorizedDataByIdQuery(id, {
        skip: !id,
    });
    const dispatch = useDispatch();

    useEffect(() => {
        if (data?.success) {
            const CredentialsData = {
                _id: data?.data?._id,
                name: data?.data?.name,
                email: data?.data?.email,
                live_chat: data?.data?.live_chat,
            };

            dispatch(setCredentials(CredentialsData));

            navigate("/");
            return;
        }

        if (isError) {
            navigate("/unauthorized");
        }
    }, [data, isError, navigate, dispatch]);


    if (isLoading) {
        return (<>
            <div style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <Spinner animation="border" variant="danger" />
            </div>
        </>);
    }

    return (
        <>
        </>
    );
};

export default AuthorizedPage;
